export const environment = {
  production: false,
  apiUrl: 'https://dev.qr.parkingqr.us/api'  // default Cloudflare Workers local port
};